import { __assign, __read, __rest } from "tslib";
import React from 'react';
import { cx } from 'emotion';
import _ from 'lodash';
import { SegmentSelect, useExpandableLabel } from './';
import { getSegmentStyles } from './styles';
import { InlineLabel } from '../Forms/InlineLabel';
import { useStyles } from '../../themes';
export function Segment(_a) {
    var _b;
    var options = _a.options, value = _a.value, onChange = _a.onChange, Component = _a.Component, className = _a.className, allowCustomValue = _a.allowCustomValue, placeholder = _a.placeholder, disabled = _a.disabled, rest = __rest(_a, ["options", "value", "onChange", "Component", "className", "allowCustomValue", "placeholder", "disabled"]);
    var _c = __read(useExpandableLabel(false), 4), Label = _c[0], width = _c[1], expanded = _c[2], setExpanded = _c[3];
    var styles = useStyles(getSegmentStyles);
    if (!expanded) {
        var label = _.isObject(value) ? value.label : value;
        return (React.createElement(Label, { disabled: disabled, Component: Component || (React.createElement(InlineLabel, { className: cx(styles.segment, (_b = {},
                    _b[styles.queryPlaceholder] = placeholder !== undefined && !value,
                    _b[styles.disabled] = disabled,
                    _b), className) }, label || placeholder)) }));
    }
    return (React.createElement(SegmentSelect, __assign({}, rest, { value: value && !_.isObject(value) ? { value: value } : value, options: options, width: width, onClickOutside: function () { return setExpanded(false); }, allowCustomValue: allowCustomValue, onChange: function (item) {
            setExpanded(false);
            onChange(item);
        } })));
}
//# sourceMappingURL=Segment.js.map